<template>
  <div class="state-box">
    <div class="state" @click="gotoState">
      免责声明
    </div>
    <div class="text" v-if="isShow">
      <h1 class="title">免责声明</h1>
      <span class="desc">本宣传资料仅作为邀约邀请，不构成邀约内容，资料所涉及的项目配套、教育机构位置、商业配套、市政道路等信息的介绍，由本公司根据项目周边现状或政府的规划文件或相关报道等搜集而来，仅供参考，实际呈现以政府及相关单位最终建设为准，并不意味着本公司对此作出任何承诺，买卖双方的权利义务以双方签署的商品房买卖合同及相关协议约定为准。</span>
      <div class="goBack" @click="gotoBack">X</div>
    </div>
  </div>

  

</template>

<script>
export default {
  name:'Statement',
  data(){
    return {
      isShow:false,

    }
  },
  methods:{
  gotoState(){
    this.isShow = true

  },
  gotoBack(){
    this.isShow = false
  }
}

}
</script>

<style lang="scss" scoped>
.state-box {

  .state {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  box-sizing: border-box;
  padding: 0 1rem;
  right:0;
  bottom: 5rem;
  width: 2rem;
  height: 5rem;
   color: #fff;
  font-size: 0.8rem;
  white-space: wrap;
  background-color: rgba(0, 0, 0, 0.7);
}
.text {
  position: absolute;
  left:0;
  top:0;
  z-index: 999;
  width:100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-top: 4rem;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  
  .title {
    font-weight: normal;
    margin-bottom: 1rem;
  }
  .desc {
    width:90%;
    text-indent: 2rem;
    text-align: justify;
    font-size: 1rem;
    line-height: 2rem;
  }
  .goBack {
    position: absolute;
    bottom: 6rem;
    font-size: 2.4rem;

  }
}
}


</style>